<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field v-if="app.id" label="ID" v-model="app.id" disabled>
        </v-text-field>
        <v-text-field label="Name" v-model="app.name" :rules="nameRules" required>
        </v-text-field>
        <v-text-field label="Auth Token" v-model="app.authToken" :rules="tokenRules" required>
        </v-text-field>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Save</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['app', 'onSubmit'],
  data() {
    return {
      valid: true,
      nameRules: [
        (element) => {
          if (element.trim() === '') return 'The name is required';
          return true;
        },
      ],
      tokenRules: [
        (element) => {
          if (element.trim() === '') return 'The auth token is required';

          return true;
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
